import { useContext } from "react";
import {DivarAuthContext} from "../tools/contexts/DivarAuthContext";


const useDivarAuth = () => {
    const context = useContext(DivarAuthContext);
    if (!context) {
        throw new Error("useAuth must be used within a DivarAuthProvider");
    }

    return context;
};

export default useDivarAuth;